export const PARAM_SHOW_ITEM_DETAILS = 'showDetails';
export const PARAM_SHOW_ITEM_PREVIEW = 'showPreview';
export const PARAM_FILE_ID = 'fileId';
export const PARAM_PATH = 'path';
export const PARAM_PAGE = 'page';
export const PARAM_PAGE_SIZE = 'pageSize';
export const PARAM_SORT = 'sort'
export const PARAM_ORDER = 'order'
export const PARAM_LAYOUT = 'layout';
export const PARAM_SEARCH = 'search';
export const PARAM_FILE_TYPES = 'fileTypes';
export const PARAM_RECENTLY_ADDED = 'noOfDays';
export const PARAM_IS_FAVORITE = 'isFavorite';
export const PARAM_IS_PUBLIC = 'isPublic';
export const PARAM_TYPE = 'type';
export const STORAGE_OBJECTS_QUERY_KEY = 'StorageObjectsQuery';
export const AUTH_QUERY_KEY = 'AuthQuery';
export const NO_DISCLAIMER_KEY = 'No Disclaimer';
export const WATERMARK = 'Watermark';
export const ROLE_PREFIX = 'ROLE_';
export const SCOPE_PREFIX = 'SCOPE_';
export const LENGTH_LIMIT_URL_QUERY_PARAMETER = 2000 as number;
export const SEARCH_TERM_MINIMAL_CHARACTERS_LENGTH = 2 as number;
export const OWNER_KEYWORD = 'OWNER';
export const ONE_MEGABYTE_BITS = 1024 * 1024;
